export const DuplicateLine = ({ width = 24, height = 24, disabled, ...rest }) => {
	const fill = disabled ? '#E6E6E6' : '#566B76'

	return (
		<svg width={width} height={height} {...rest} viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
			<path
				d="M23.5 24C23.7762 24 24 23.7762 24 23.5V3.5C24 3.22384 23.7762 3 23.5 3H3.5C3.22384 3 3 3.22384 3 3.5V23.5C3 23.7762 3.22384 24 3.5 24H23.5ZM23 23H4V4H23V23ZM19 1V3.5C19 3.77616 19.2238 4 19.5 4C19.7762 4 20 3.77616 20 3.5V0.5C20 0.223844 19.7762 0 19.5 0H0.5C0.223844 0 0 0.223844 0 0.5V19.5C0 19.7762 0.223844 20 0.5 20H3.5C3.77616 20 4 19.7762 4 19.5C4 19.2238 3.77616 19 3.5 19H1V1H19ZM14 18.25C14 18.5262 13.7762 18.75 13.5 18.75C13.2238 18.75 13 18.5262 13 18.25V8.75C13 8.47384 13.2238 8.25 13.5 8.25C13.7762 8.25 14 8.47384 14 8.75V18.25ZM8.75 14C8.47388 14 8.25 13.7762 8.25 13.5C8.25 13.2238 8.47384 13 8.75 13H18.25C18.5262 13 18.75 13.2238 18.75 13.5C18.75 13.7762 18.5262 14 18.25 14H8.75Z"
				fill={fill}
			/>
		</svg>
	)
}
